import { Component, OnInit, Input, output, inject } from '@angular/core';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { FileService } from '../attachment-dialog/file.service';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { IMPRESSIONEVENTS, INTERACTEVENTS, TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-attachment',
  standalone: true,
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  imports: [MatCard, MatSlideToggle, MatCardContent, MatChipListbox, MatChipOption, MatButton],
})
export class AttachmentComponent implements OnInit {
  dialog = inject(MatDialog);
  private fileService = inject(FileService);
  private telemetryService = inject(TelemetryService);

  list: string[] = ['abc.jpg', 'def.jpg', 'ghi.jpg'];
  filesList: File[] = [];
  allFilesList = [];
  fileNameArray = [];
  editFileNameArray = [];
  bool: boolean;
  showAttachmentMode = false;
  showAttachment: boolean;
  multifileUpload: boolean;
  lastindex: number;
  fileMerge = [];
  filename = [];
  fileArray = [];
  deletedFile = [];
  newArrayfile: any;
  fileDeleteSub = new Subject();
  key: number;
  multiSelectFlag = false;

  @Input() ModuleData: any;

  @Input() SendfileInput: any;
  @Input() toggleBtn = true;
  @Input() allowedTypes: string;
  readonly fileOutput = output<object>();
  @Input() uploadType = 'multiple';
  @Input() editId: any;
  @Input() lable: string;

  ngOnInit() {
    this.telemetryService.impression({
      type: IMPRESSIONEVENTS.VIEW,
      itype: 'Component',
      pageid: 'AttachmentComponent',
      detail: 'OnInit Load',
    });
    this.showAttachmentMode = true;
    if (this.editId) {
      this.showAttachmentMode = true;
      this.fileService.getFileData(this.editId['objectId'], this.editId['objectType']).subscribe(
        (res) => {
          const obj = res.id;
          const mapped = Object.keys(obj).map((key) => ({ fileName: key, fileID: obj[key] }));
          mapped.forEach((elem) => {
            this.editFileNameArray.push({ fileName: elem.fileName, fileID: elem.fileID });
          });
        },

        (_err) => {},
      );
    }
  }
  openDialog() {
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'AttachmentComponent',
      detail: 'Button Clicked',
    });
    const dialogRef = this.dialog.open(AttachmentDialogComponent, {
      width: '500px',
      data: {
        attachmentList: this.filesList,
        ModuleData: this.SendfileInput,
        allowedfileType: this.allowedTypes,
        uploadType: this.uploadType,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const fileArrValues = [];
        //for single file
        if (this.uploadType == 'single') {
          this.allFilesList.splice(0, this.allFilesList.length);
          this.fileNameArray.splice(0, this.fileNameArray.length);
        }
        //For New Files
        result.forEach((fileValue) => {
          if (this.fileNameArray.indexOf(fileValue.name) === -1) {
            this.fileNameArray.push(fileValue.name);
            this.allFilesList.push(fileValue);
          } else {
            this.allFilesList.forEach((fileArr) => {
              if (fileValue.name != fileArr['name']) {
                fileArrValues.push(fileArr);
              }
            });
            //Override the last same name file
            delete this.allFilesList;
            this.allFilesList = fileArrValues;
            this.allFilesList.push(fileValue);
          }
        });

        if (this.editFileNameArray) {
          //For Edit Files
          const editFileNameArrayTemp = [];
          const deletedFileTemp = [];

          this.editFileNameArray.forEach((fileValue) => {
            result.filter(function (data) {
              if (data['name'] == fileValue.fileName) {
                deletedFileTemp.push(fileValue);
              } else {
                editFileNameArrayTemp.push(fileValue);
              }
            });
          });
          // debugger
          delete this.editFileNameArray;
          this.editFileNameArray = editFileNameArrayTemp;
          if (deletedFileTemp && deletedFileTemp.length > 0) {
            //delete this.deletedFile;
            this.deletedFile = deletedFileTemp;
          }
        }

        this.onFileSelected(this.allFilesList);
      }
    });
  }

  removeParent(closebtn, fileID) {
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'AttachmentComponent',
      detail: 'removeParent() called' + fileID,
    });
    const FileValuesDelete = [];
    this.filesList.forEach((fileValue) => {
      if (fileValue.name != fileID) {
        FileValuesDelete.push(fileValue);
      }
    });
    delete this.allFilesList;
    this.allFilesList = FileValuesDelete;

    const FileValuesDeleteArray = [];
    this.fileNameArray.forEach((fileValue) => {
      if (fileValue != fileID) {
        FileValuesDeleteArray.push(fileValue);
      }
    });
    delete this.fileNameArray;
    this.fileNameArray = FileValuesDeleteArray;

    const fileMerge = this.allFilesList;
    const deletedFile = this.deletedFile;
    this.fileOutput.emit({ fileMerge, deletedFile });
  }

  removeEditParent(closebtn, fileID) {
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'AttachmentComponent',
      detail: 'removeEditParent() called' + fileID,
    });
    const FileValuesDelete = [];
    this.editFileNameArray.forEach((fileValue) => {
      if (fileValue.fileID != fileID) {
        FileValuesDelete.push(fileValue);
      } else {
        this.deletedFile.push(fileValue);
      }
      const fileMerge = this.allFilesList;
      const deletedFile = this.deletedFile;
      this.fileOutput.emit({ fileMerge, deletedFile });
    });
    delete this.editFileNameArray;
    this.editFileNameArray = FileValuesDelete;
  }

  downloadFile(fileID: any) {
    this.telemetryService.interact({
      type: INTERACTEVENTS.CLICK,
      itype: 'Method',
      pageid: 'AttachmentComponent',
      detail: 'downloadFile() called' + fileID,
    });
    this.fileService.downloadFile(fileID).subscribe(
      (res) => {
        const base64 = res.file.data;
        const link = document.createElement('a');
        link.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + base64;
        link.download = res.fileName + res.fileType;
        link.click();
      },
      (_err) => {
        //console.log(_err)
        // this.error = _err
      },
    );
  }

  //Multi Chunks
  onFileSelected(filesArray) {
    this.telemetryService.log({
      type: 'Info',
      itype: 'logging ',
      pageid: 'AttachmentComponent',
      detail: 'onFileSelected() called',
    });
    const files = filesArray;
    this.filename = [];
    this.fileMerge = [];
    const lastChunksize = 0;
    const chunkSize = 524288; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    for (const file of files) {
      this.filename.push(file.name);
      if (this.uploadType == 'single' && this.filename.length > 0) {
        this.fileMerge.splice(0, this.fileMerge.length);
      }
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    }
    const fileMerge = this.fileMerge;
    const deletedFile = this.deletedFile;
    const nameOfTheFile = this.filename.join();
    this.fileOutput.emit({ fileMerge, deletedFile, nameOfTheFile });
  }

  // uploadSingleFile(file,lastChunksize,chunkSize){
  //   this.replaceFile(this.filename[0].fileID);
  //     this.fileDeleteSub.subscribe(() =>{
  //       this.filename = [];
  //       //this.attachData = [];
  //       this.readFile(file, lastChunksize, this.myCallback.bind(this),chunkSize);
  //     })
  // }

  //  console.log('fileArray',this.fileArray)
  myCallback(file, lastChunksize, result, chunkSize) {
    this.telemetryService.log({
      type: 'Info',
      itype: 'logging ',
      pageid: 'AttachmentComponent',
      detail: 'myCallback() called' + file + lastChunksize + result + chunkSize,
    });
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    } else {
      ///end recursion
    }
  }

  readFile(file, lastChunksize: number, callback, chunkSize) {
    this.telemetryService.log({
      type: 'Info',
      itype: 'logging ',
      pageid: 'AttachmentComponent',
      detail: 'readFile() called' + file + lastChunksize + callback + chunkSize,
    });
    const fileBlob = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlob.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMerge.push(file);
        return callback(file, lastChunksize, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob);
    } else {
      return callback(file, lastChunksize, false);
    }
  }

  // replaceFile(fileID){
  //   let observable =   this.fileService.deleteFile(fileID).subscribe(
  //       (res) => {
  //           let FileValuesDelete = [];
  //           this.filename.forEach(file => {
  //               if(file.fileID != fileID)
  //               {
  //                 FileValuesDelete.push(file);
  //               }
  //           });
  //           delete this.filename;
  //           this.filename = FileValuesDelete;
  //           //this.fileSizeError = '';
  //           this.fileService.setFileUploadEvent(this.filename);
  //           let observ = this.fileDeleteSub.observers[this.fileDeleteSub.observers.length-1];
  //           this.fileDeleteSub.observers.splice(0,this.fileDeleteSub.observers.length);
  //           this.fileDeleteSub.observers.push(observ);
  //           this.fileDeleteSub.next();
  //       },
  //       (err) => {
  //        // this.error = err
  //       }
  //     );
  // }
  removeFileName() {
    this.telemetryService.log({
      type: 'Info',
      itype: 'logging ',
      pageid: 'AttachmentComponent',
      detail: 'removeFileName() called',
    });
    this.fileNameArray.splice(0, this.fileNameArray.length);
  }
}
